angular.module('gym.components').directive('sequenceCondition', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/sequences/sequenceCondition.html.slim'),
    replace: true,
    scope: {
      sequence: '=',
      step: '=',
      condition: '=',
      index: '=',
      removeCondition: '&',
      reports: '='
    },
    controller: ["$scope", function($scope) {
      $scope.defaultConditionLabel = function() {
        var trigger;
        trigger = $scope.sequence.trigger;
        return $scope.sequence.default_condition_labels[trigger];
      };
      $scope.remove = function() {
        return $scope.removeCondition({
          step: $scope.step,
          index: $scope.index
        });
      };
      $scope.isConditionDisplaying = function() {
        var trigger;
        trigger = $scope.sequence.trigger;
        return ($scope.condition.type === 'LinkedReportSequenceCondition') || ($scope.condition.type === 'DefaultSequenceCondition' && trigger);
      };
      return $scope.displayReportName = function() {
        var report;
        report = _.findWhere($scope.reports, {
          id: $scope.condition.report_id
        });
        return report.name;
      };
    }]
  };
});
